export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
// ARCHIVE
export const SET_SK_DEBT_ARCHIVE = 'SET_SK_DEBT_ARCHIVE'
